import React from "react";
import Representation from './Representation';

const DropDown = (props) => {
  return <Representation
    {...props}
  />
}

export default DropDown;